module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "overlay-mask"
  }, [_c('div', {
    staticClass: "modal-dialog modal-md",
    staticStyle: {
      "max-width": "1140px"
    }
  }, [_c('div', {
    staticClass: "modal-content modal-edit-bg",
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 edit_account_modal"
  }, [_c('div', {
    staticClass: "close_btn",
    on: {
      "click": function($event) {
        return _vm.CloseModal()
      }
    }
  }), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row long-modal"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "1px"
    }
  }, [_c('iframe', {
    staticStyle: {
      "min-width": "100%",
      "height": "800px",
      "border": "none"
    },
    attrs: {
      "id": _vm.jotFormElementID,
      "title": "Equipment Request Form",
      "onload": "window.parent.scrollTo(0,20)",
      "allowtransparency": "true",
      "allowfullscreen": "true",
      "allow": "geolocation; microphone; camera",
      "src": 'https://form.jotform.com/' + _vm.formID + '?' + _vm.prefillFields,
      "frameborder": "0",
      "scrolling": "no"
    }
  })])])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b61c92e0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b61c92e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/JotformModal.vue
// module id = 562
// module chunks = 4